import { SET_NUMBER_OF_GUESTS_FOR_SWIMMING } from '../constants/swimming';

const initialState = {
  numOfGuests: 1,
};

const swimming = (state = initialState, action) => {
  switch (action.type) {
    case SET_NUMBER_OF_GUESTS_FOR_SWIMMING: {
      const { numOfGuests } = action;
      return { numOfGuests: parseInt(numOfGuests, 10) };
    }
    default:
      return state;
  }
};

export default swimming;
